export default __webpack_public_path__ + "static/media/arduino-icon.e0e58cf9.svg";